import { Link, useLocation } from "react-router-dom";
import { Academy } from "../../icons";
import { useAppSelector } from "../../hooks/store-hooks";
import { useEffect, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { AcademyLock, DownButtonIcon } from "../../icons/academy-icons";
import { AcademyList } from "../../store/slices/academySlice";
import { MixpanelEvent, trackEvent } from "../../analytics/mixpanel";

const AcademyRootPage = ["academy", "courses", "livestream", "news"];

const defaultDropdownList = [
  {
    id: "all",
    title: "All",
  },
  {
    id: "courses",
    title: "Courses",
  },
  {
    id: "livestream",
    title: "Livestream",
  },
  {
    id: "news",
    title: "News",
  },
] as AcademyList[];

const AcademySidebar = () => {
  const location = useLocation();
  const [dropdownList, setDropdownList] =
    useState<AcademyList[]>(defaultDropdownList);
  const { dropdown_list } = useAppSelector((state) => state.academy);
  const [isDropdownOpen, setDropdownOpen] = useState(true);
  const [lastPathSegment, setLastPathSegment] = useState("");

  useEffect(() => {
    setLastPathSegment(location.pathname.split("/").slice(3).join("/") || "");
  }, [location.pathname]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const resolveLink = (id: string): string => {
    if (id === "all") return ROUTES.ACADEMY_DEFAULT;
    if (AcademyRootPage.includes(id)) {
      return `${ROUTES.ACADEMY_DEFAULT}/${id}`;
    }
    if (location.pathname.includes("courses"))
      return `${ROUTES.ACADEMY_COURSES}/${id}`;
    return ROUTES.ACADEMY_DEFAULT;
  };

  useEffect(() => {
    if (dropdown_list.length) {
      setDropdownList(dropdown_list);
    }
  }, [dropdown_list]);

  return (
    <aside className="!w-80 bg-gray-100 p-4 md:p-6 md:pt-0 !pt-0 md:pl-0 m-auto">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <nav>
          <div className="flex items-center gap-2 pb-2">
            <Academy />
            <h3 className="text-xl font-semibold text-black">Academy</h3>
          </div>
          <ul className="flex flex-col">
            {dropdownList.map((item) => (
              <div key={item.id}>
                {item.dropdown && item.dropdown.length > 0 ? (
                  <div>
                    <Link to={resolveLink(item.id)} className="block">
                      <button
                        onClick={handleDropdownToggle}
                        className={`font-semibold text-lg text-gray-500 transition-colors duration-200 p-2 rounded-lg cursor-pointer ${
                          (location.pathname === "/academy" &&
                            item.id === "all") ||
                          location.pathname.includes(item.id)
                            ? "bg-[#E7ECFC]"
                            : ""
                        } flex justify-between w-full items-center `}
                      >
                        <p>{item.title} </p>
                        <p>
                          {isDropdownOpen ? (
                            <DownButtonIcon width={14} rotate={180} />
                          ) : (
                            <DownButtonIcon width={14} />
                          )}
                        </p>
                      </button>
                    </Link>
                    {isDropdownOpen && (
                      <ul className="pl-4">
                        {item.dropdown.map((subItem) => (
                          <li
                            key={subItem.id}
                            className={`mt-2 font-medium text-base text-gray-400 transition-colors duration-200 px-2 py-1 rounded-lg ${
                              subItem.id
                                ? "cursor-pointer"
                                : "cursor-not-allowed"
                            } ${
                              lastPathSegment === subItem.id
                                ? "bg-[#E7ECFC]"
                                : ""
                            }`}
                          >
                            {subItem.id ? (
                              <Link
                                to={resolveLink(subItem.id)}
                                className="block"
                                onClick={() => {
                                  const path = resolveLink(subItem.id);
                                  const pathSegments = path.split("/");
                                  const lastSegmentIndex =
                                    pathSegments.length - 1;
                                  const itemId =
                                    pathSegments.length > 2
                                      ? pathSegments[lastSegmentIndex]
                                      : subItem.id;

                                  const type =
                                    lastSegmentIndex === 5
                                      ? "episode"
                                      : "course";
                                  trackEvent(MixpanelEvent.CARD_CLICK, {
                                    type: type,
                                    [`${type}_id`]: itemId,
                                    [`${type}_title`]: subItem.title,
                                  });
                                }}
                              >
                                {subItem.title}
                              </Link>
                            ) : (
                              <div className="flex justify-between p-[6px]">
                                <p>{subItem.title}</p>
                                <AcademyLock width={18} height={18} />
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <Link
                    to={resolveLink(item.id)}
                    className="block"
                    onClick={() => {
                      trackEvent("ACADEMY_TAB_PRESS", {
                        tab_name: item.id,
                      });
                    }}
                  >
                    <div
                      className={`font-semibold text-lg text-gray-500 transition-colors duration-200 px-2 py-2 rounded-lg cursor-pointer ${
                        (location.pathname === "/academy" &&
                          item.id === "all") ||
                        location.pathname.includes(item.id)
                          ? "bg-[#E7ECFC]"
                          : ""
                      }`}
                    >
                      {item.title}
                    </div>
                  </Link>
                )}
              </div>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default AcademySidebar;
